import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  initResetPasswordRequest: ['email'],
  initResetPasswordSuccess: null,
  initResetPasswordFailure: ['error', 'errorCode'],
  finishResetPasswordRequest: ['key', 'password'],
  finishResetPasswordSuccess: null,
  finishResetPasswordFailure: ['error'],
  newPasswordChanged: ['newPassword'],
  confirmNewPasswordChanged: ['confirmNewPassword'],
  emailChanged: ['email'],
  clearResetPassword: null,
});

export const ResetPasswordTypes = Types;
export default Creators;



// WEBPACK FOOTER //
// ./src/state/actions/ResetPasswordActions.js